import { Col, Container, Row } from "reactstrap";
import styles from "./CRM.module.scss";
import { useState } from "react";
import Tabs from "../../../../components/common/Tabs/Tabs";
import CustomerList from "./CustomerList/CustomerList";
import CommunicationLog from "./CommunicationLog/CommunicationLog";
import CustomerSegmentation from "./CustomerSegmentation/CustomerSegmentation";

const CRM = () => {
  const tabs = ["Customer List", "Communication Log", "Customer Segmentation"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const leftcolStatsData = [
    { label: "Total Number of Customers:", value: "1,500" },
    { label: "Average Order Value (AOV):", value: "$75" },
    { label: "Customer Satisfaction Score (CSAT):", value: "4.2/5" },
    { label: "Customer Engagement Rate", value: "35%" },
    { label: "Email Open Rate:", value: "25%" },
  ];

  const rightcolStatsData = [
    { label: "Response Time:", value: "24 hours" },
    { label: "Resolution Time:", value: "15%" },
    { label: "Churn Rate:", value: "10%" },
    { label: "Customer Acquisition Cost (CAC):", value: "$50" },
    { label: "Customer Retention Cost (CRC):", value: "$30" },
  ];

  return (
    <Container fluid className={styles["wrapper"]}>
      <div class="fw-semibold fs-4">CRM (Customer Relationship Management)</div>

      <div class="fw-semibold fs-5 mt-3 mb-2">Metrices</div>

      <Container fluid className="p-0 px-lg-3 mb-2">
        <Row className="g-0 row-gap-3">
          <Col xl={6} className="pe-xl-3">
            <div className={styles["stats"]}>
              {leftcolStatsData.map((item, index) => (
                <Row key={index} className="fw-medium g-0">
                  <Col>{item.label}</Col>
                  <Col xs="4" className={styles["text-yellow"]}>
                    {item.value}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
          <Col xl={6} className="ps-xl-3">
            <div className={styles["stats"]}>
              {rightcolStatsData.map((item, index) => (
                <Row key={index} className="fw-medium g-0">
                  <Col>{item.label}</Col>
                  <Col xs="4" className={styles["text-yellow"]}>
                    {item.value}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
        </Row>
      </Container>

      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "Customer List" && <CustomerList />}
      {activeTab === "Communication Log" && <CommunicationLog />}
      {activeTab === "Customer Segmentation" && <CustomerSegmentation />}

    </Container>
  );
};

export default CRM;